import type { IFormGenUiTitleSchema, TJSONSchema } from "@artifact-management/json-dynamic-form";
import InfoIcon from "@mui/icons-material/Info";
import { Stack, Tooltip, Typography } from "@mui/material";
import type { FieldValues } from "react-hook-form";
import type { IFormGenComponentProps } from "../index";

export interface IFormGenTitleProps<Schema extends TJSONSchema, T extends FieldValues>
  extends IFormGenComponentProps<Schema, T> {
  uiSchemaElement: IFormGenUiTitleSchema<Schema>;
}

export const FormGenTitle = <Schema extends TJSONSchema, T extends FieldValues>({
  uiSchemaElement,
}: IFormGenTitleProps<Schema, T>) => (
  <Stack sx={{ flexDirection: "row", gap: 1, alignItems: "center" }}>
    <Typography variant="subtitle2SemiBold" color="primary">
      {uiSchemaElement.title}
    </Typography>
    {uiSchemaElement.tooltip && (
      <Tooltip title={uiSchemaElement.tooltip}>
        <InfoIcon fontSize="small" color="primary" />
      </Tooltip>
    )}
  </Stack>
);
